import { render } from "./IsActiveBadge.vue?vue&type=template&id=08f97c8d"
import script from "./IsActiveBadge.vue?vue&type=script&lang=js"
export * from "./IsActiveBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__